module.exports = __webpack_public_path__ + "static/media/greyOffenseIcon.846608fe.svg";